import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const AddNoteFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    fill={color}
    viewBox="0 0 24 24"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M14.34 3.6H7.96c-2.3 0-4.18 1.8-4.18 4.01v8.55c0 2.2 1.88 4.01 4.18 4.01h4.4l.06-5.57c0-1.29 1.02-2.35 2.31-2.37l3.79-.07V7.6c0-2.2-1.88-4.01-4.18-4.01v.01Zm-3.09 8.71H7.14a.77.77 0 0 1-.77-.77c0-.42.35-.77.77-.77h4.11c.43 0 .77.35.77.77 0 .42-.35.77-.77.77Zm3.01-3.38H7.14a.77.77 0 0 1-.77-.77c0-.42.35-.77.77-.77h7.12c.43 0 .77.35.77.77 0 .42-.35.77-.77.77Z"
        fill={color}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.25 14.61a.8.8 0 0 0-1.6 0v2.04h-2.04a.8.8 0 0 0 0 1.6h2.04v2.05a.8.8 0 0 0 1.6 0v-2.05h2.05a.8.8 0 0 0 0-1.6h-2.05v-2.04Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default AddNoteFilled
